import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "numberField", "numberInput"];

  update(event) {
    // Get all radio buttons within the group
    const allLabels = this.element.closest("div").querySelectorAll("label");

    allLabels.forEach((label) => {
      this.resetStyles(label);
      const numberField = label.querySelector("[data-radio-button-target='numberField']");
      if (numberField) numberField.classList.add("hidden");
    });

    // Apply styles to the selected label
    const selectedLabel = event.target.closest("label");
    this.applyStyles(selectedLabel);

    const numberField = selectedLabel.querySelector("[data-radio-button-target='numberField']");
    if (numberField) numberField.classList.remove("hidden");
  }

  increment(event) {
    const numberInput = event.target.closest("label").querySelector("[data-radio-button-target='numberInput']");
    const hiddenInput = event.target.closest("label").querySelector("[data-radio-button-target='hiddenNumberInput']");
    if (numberInput) {
      numberInput.value = parseInt(numberInput.value, 10) + 1;
      numberInput.setAttribute("value", numberInput.value);
      hiddenInput.value = numberInput.value;
      hiddenInput.setAttribute("value", numberInput.value);
    }
  }

  decrement(event) {
    const numberInput = event.target.closest("label").querySelector("[data-radio-button-target='numberInput']");
    const hiddenInput = event.target.closest("label").querySelector("[data-radio-button-target='hiddenNumberInput']");
    if (numberInput) {
      const newValue = Math.max(1, parseInt(numberInput.value, 10) - 1);
      numberInput.value = newValue;
      numberInput.setAttribute("value", newValue);
      hiddenInput.value = numberInput.value;
      hiddenInput.setAttribute("value", numberInput.value);
    }
  }

  resetStyles(label) {
    // Reset label styles
    label.classList.remove("bg-[#12273e]", "text-white", "border-[#12273e]");
    label.classList.add("bg-white", "text-[#12273e]", "border-[#e7e9ec]", "hover:bg-gray-100");

    const outerCircle = label.querySelector("span.h-6.w-6");
    if (outerCircle) {
      outerCircle.classList.remove("bg-[#12273e]", "border-white");
      outerCircle.classList.add("bg-white", "border-[#12273e]");
    }

    const innerCircle = label.querySelector("span.h-4.w-4");
    if (innerCircle) {
      innerCircle.classList.add("hidden");
      innerCircle.classList.remove("bg-white");
    }

    const numberInput = label.querySelector("[data-radio-button-target='numberInput']");
    if (numberInput) numberInput.value = 1;
  }

  applyStyles(label) {
    // Apply styles to the selected label
    label.classList.add("bg-[#12273e]", "text-white", "border-[#12273e]");
    label.classList.remove("bg-white", "text-[#12273e]", "border-[#e7e9ec]", "hover:bg-gray-100");

    const outerCircle = label.querySelector("span.h-6.w-6");
    if (outerCircle) {
      outerCircle.classList.add("bg-[#12273e]", "border-white");
      outerCircle.classList.remove("bg-white", "border-[#12273e]");
    }

    const innerCircle = label.querySelector("span.h-4.w-4");
    if (innerCircle) {
      innerCircle.classList.remove("hidden");
      innerCircle.classList.add("bg-white");
    }
  }
}
